"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }
  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }
  return ExtendableBuiltin;
}
var env = 'browser';
if (typeof window === 'undefined') {
  global.fetch = require('node-fetch').default;
  env = 'node';
}
var HeliumClientError = function (_extendableBuiltin2) {
  _inherits(HeliumClientError, _extendableBuiltin2);
  var _super = _createSuper(HeliumClientError);
  function HeliumClientError(what, response, expected) {
    var _this;
    _classCallCheck(this, HeliumClientError);
    var msg = what;
    if (response.statusCode !== expected) {
      msg += " returned ".concat(response.statusCode, " (expected ").concat(expected, ")");
    }
    _this = _super.call(this, msg);
    Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    _this.name = _this.constructor.name;
    _this.status = response.statusCode;
    _this.expected = expected;
    _this.json = response.json;
    return _this;
  }
  return _createClass(HeliumClientError);
}(_extendableBuiltin(Error));
var LiveServer = function () {
  function LiveServer(endpoint) {
    _classCallCheck(this, LiveServer);
    this.endpoint = endpoint;
  }
  _createClass(LiveServer, [{
    key: "inject",
    value: function () {
      var _inject = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(origRequest) {
        var overrides,
          request,
          _origRequest$payload$,
          url,
          origResponse,
          statusCode,
          headers,
          response,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              overrides = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              request = {
                method: origRequest.method,
                headers: origRequest.headers
              };
              if (origRequest.payload) {
                request.body = ((_origRequest$payload$ = origRequest.payload.constructor) === null || _origRequest$payload$ === void 0 ? void 0 : _origRequest$payload$.name) === 'FormData' ? origRequest.payload : JSON.stringify(origRequest.payload);
              }
              url = overrides.url || "".concat(this.endpoint).concat(origRequest.url);
              _context.next = 6;
              return fetch(url, request);
            case 6:
              origResponse = _context.sent;
              statusCode = origResponse.status;
              headers = origResponse.headers.raw || origResponse.headers.map ? Object.entries(origResponse.headers.raw ? origResponse.headers.raw() : origResponse.headers.map).reduce(function (a, _ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  k = _ref2[0],
                  v = _ref2[1];
                a[k] = Array.isArray(v) && v.length === 1 ? v[0] : v;
                return a;
              }, {}) : origResponse.headers;
              headers['User-Agent'] = "OpenPath-HeliumClient/1.0 ".concat(env, " (+engineering@openpath.com)");
              response = {
                statusCode: statusCode,
                headers: headers
              };
              _context.prev = 11;
              if (!(response.headers['content-type'] === 'application/xml')) {
                _context.next = 18;
                break;
              }
              _context.next = 15;
              return origResponse.text();
            case 15:
              response.payload = _context.sent;
              _context.next = 26;
              break;
            case 18:
              if (!(statusCode !== 204)) {
                _context.next = 24;
                break;
              }
              _context.next = 21;
              return origResponse.json();
            case 21:
              _context.t0 = _context.sent;
              _context.next = 25;
              break;
            case 24:
              _context.t0 = null;
            case 25:
              response.json = _context.t0;
            case 26:
              _context.next = 30;
              break;
            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](11);
            case 30:
              return _context.abrupt("return", response);
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[11, 28]]);
      }));
      function inject(_x) {
        return _inject.apply(this, arguments);
      }
      return inject;
    }()
  }]);
  return LiveServer;
}();
function generateQueryString(queryParams) {
  var queryString = '?';
  if (queryParams) {
    Object.keys(queryParams).map(function (key) {
      var rawValue = queryParams[key];
      if (Array.isArray(rawValue)) {
        rawValue.forEach(function (elem) {
          var value = encodeURIComponent(elem);
          var pair = "".concat(key, "=").concat(value, "&");
          queryString += pair;
        });
      } else {
        var value = encodeURIComponent(rawValue);
        var pair = "".concat(key, "=").concat(value, "&");
        queryString += pair;
      }
    });
  }
  queryString = queryString.slice(0, -1);
  return queryString;
}
var BaseClient = function () {
  function BaseClient(server) {
    var _this2 = this;
    var _token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var postRequestCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, BaseClient);
    _defineProperty(this, "swaggerOp", function () {
      var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(operationId) {
        var args,
          op,
          _op,
          method,
          pathTemplate,
          parameters,
          responseCode,
          withPayload,
          withQuery,
          path,
          _iterator,
          _step,
          p,
          payload,
          queryParams,
          flags,
          result,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              args = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : [];
              if (!_this2.spec) _this2.spec = BaseClient.getDefaultSpec();
              op = _this2.spec[operationId];
              if (op) {
                _context2.next = 5;
                break;
              }
              throw new Error("Unknown operationId ".concat(operationId));
            case 5:
              _op = _slicedToArray(op, 6), method = _op[0], pathTemplate = _op[1], parameters = _op[2], responseCode = _op[3], withPayload = _op[4], withQuery = _op[5];
              path = pathTemplate;
              _iterator = _createForOfIteratorHelper(parameters);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  p = _step.value;
                  path = path.replace("{".concat(p, "}"), args.shift());
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              payload = withPayload ? args.shift() : null;
              queryParams = withQuery ? args.shift() : null;
              flags = args.length ? args.shift() : undefined;
              _context2.next = 14;
              return _this2._request(responseCode, method, path, payload, queryParams, flags);
            case 14:
              result = _context2.sent;
              return _context2.abrupt("return", result);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "withHeaders", function () {
      var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var ret = new BaseClient(_this2.server, _this2.token, _objectSpread(_objectSpread({}, _this2.headers), headers), _this2.postRequestCallback);
      ret.isRaw = _this2.isRaw;
      return ret;
    });
    _defineProperty(this, "raw", function () {
      var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var ret = new BaseClient(_this2.server, _this2.token, _objectSpread(_objectSpread({}, _this2.headers), headers), _this2.postRequestCallback);
      ret.isRaw = true;
      return ret;
    });
    _defineProperty(this, "setToken", function (token) {
      _this2.token = token;
    });
    _defineProperty(this, "requestExternal", _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var expectCode,
        method,
        url,
        payload,
        queryParams,
        flags,
        _args3 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            expectCode = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
            method = _args3.length > 1 ? _args3[1] : undefined;
            url = _args3.length > 2 ? _args3[2] : undefined;
            payload = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
            queryParams = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {};
            flags = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : {
              headers: {},
              firePostRequestCallback: true
            };
            return _context3.abrupt("return", _this2._request(expectCode, method, url, payload, queryParams, flags));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(this, "_request", function () {
      var _ref5 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(expectCode, method, urlpath, payload, queryParams) {
        var flags,
          queryString,
          _flags,
          overrides,
          headers,
          _flags$firePostReques,
          firePostRequestCallback,
          request,
          _payload$constructor,
          r,
          limit,
          offset,
          expectedLength,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              flags = _args4.length > 5 && _args4[5] !== undefined ? _args4[5] : {
                firePostRequestCallback: true,
                overrides: {},
                headers: {}
              };
              queryString = generateQueryString(queryParams);
              if (!flags) {
                flags = {
                  firePostRequestCallback: true,
                  overrides: {},
                  headers: {}
                };
              }
              _flags = flags, overrides = _flags.overrides, headers = _flags.headers, _flags$firePostReques = _flags.firePostRequestCallback, firePostRequestCallback = _flags$firePostReques === void 0 ? true : _flags$firePostReques;
              if (!(expectCode && isNaN(expectCode))) {
                _context4.next = 6;
                break;
              }
              throw new HeliumClientError('Must pass expectCode as first param');
            case 6:
              request = {
                method: method,
                url: urlpath + queryString,
                headers: Object.assign({
                  Accept: 'application/json, application/xml'
                }, _objectSpread(_objectSpread({}, _this2.headers), headers))
              };
              if (_this2.token && !(overrides && overrides.url)) {
                request.headers.Authorization = _this2.token;
              }
              if (payload) {
                if (((_payload$constructor = payload.constructor) === null || _payload$constructor === void 0 ? void 0 : _payload$constructor.name) === 'FormData') {
                  if (_this2.server instanceof LiveServer) {
                    delete request.headers['Content-Type'];
                    request.payload = payload;
                  } else {
                    request.headers = _objectSpread(_objectSpread({}, request.headers), payload.getHeaders());
                    request.payload = payload.getBuffer();
                  }
                } else {
                  request.headers['Content-Type'] = 'application/json';
                  request.payload = payload;
                }
              }
              _context4.next = 11;
              return _this2.server.inject(request, overrides);
            case 11:
              r = _context4.sent;
              if (!r.json && r.payload) {
                if (r.payload[0] === '[' || r.payload[0] === '{') r.json = JSON.parse(r.payload);else if (r.headers['content-type'] === 'application/xml') r.json = {
                    data: r.payload
                  };
              }
              if (!firePostRequestCallback) {
                _context4.next = 17;
                break;
              }
              if (!_this2.postRequestCallback) {
                _context4.next = 17;
                break;
              }
              _context4.next = 17;
              return _this2.postRequestCallback(expectCode, r);
            case 17:
              if (!_this2.isRaw) {
                _context4.next = 19;
                break;
              }
              return _context4.abrupt("return", r);
            case 19:
              if (!(expectCode && r.statusCode !== expectCode)) {
                _context4.next = 21;
                break;
              }
              throw new HeliumClientError("".concat(method, " ").concat(urlpath), r, expectCode);
            case 21:
              if (!(r.statusCode === 204)) {
                _context4.next = 23;
                break;
              }
              return _context4.abrupt("return", null);
            case 23:
              if (!(r.json && r.json.filteredCount)) {
                _context4.next = 29;
                break;
              }
              limit = queryParams && queryParams.limit || 10;
              offset = queryParams && queryParams.offset || 0;
              expectedLength = offset + limit < r.json.filteredCount ? limit : r.json.filteredCount - offset;
              if (!(r.json.data.length < expectedLength)) {
                _context4.next = 29;
                break;
              }
              throw new HeliumClientError("".concat(method, " ").concat(urlpath, " returned too few records in limited response (expected ").concat(expectedLength, " of ").concat(r.json.filteredCount, " total filtered records, but got ").concat(r.json.data.length, ")"), r, expectCode);
            case 29:
              return _context4.abrupt("return", r.json.data);
            case 30:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3, _x4, _x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "_PUT", function (expectCode, urlpath, payload, flags) {
      return _this2._request(expectCode, 'PUT', urlpath, payload, null, flags);
    });
    _defineProperty(this, "_PATCH", function (expectCode, urlpath, payload, flags) {
      return _this2._request(expectCode, 'PATCH', urlpath, payload, null, flags);
    });
    _defineProperty(this, "_POST", function (expectCode, urlpath, payload, queryParams, flags) {
      return _this2._request(expectCode, 'POST', urlpath, payload, queryParams, flags);
    });
    _defineProperty(this, "_GET", function (expectCode, urlpath, queryParams, flags) {
      return _this2._request(expectCode, 'GET', urlpath, null, queryParams, flags);
    });
    _defineProperty(this, "_DELETE", function (expectCode, urlpath, flags) {
      return _this2._request(expectCode, 'DELETE', urlpath, null, null, flags);
    });
    _defineProperty(this, "login", function () {
      var _ref6 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5(payload) {
        var data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this2._POST(201, '/auth/login', payload);
            case 2:
              data = _context5.sent;
              _this2.token = data.token;
              return _context5.abrupt("return", data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x8) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(this, "logout", _asyncToGenerator(_regeneratorRuntime().mark(function _callee6() {
      var data;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _this2._POST(204, '/auth/logout', {});
          case 2:
            data = _context6.sent;
            _this2.token = null;
            return _context6.abrupt("return", data);
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    })));
    _defineProperty(this, "refreshLogin", _asyncToGenerator(_regeneratorRuntime().mark(function _callee7() {
      var response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _this2._POST(201, "/auth/accessTokens/refresh", null, null, {
              firePostRequestCallback: false
            });
          case 2:
            response = _context7.sent;
            if (_this2.isRaw && response.json && response.json.data) {
              _this2.token = response.json.data.token;
            } else {
              _this2.token = response.token;
            }
            return _context7.abrupt("return", response);
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    })));
    _defineProperty(this, "checkMaintenanceEndpoint", function (maintenanceUrl) {
      return _this2._GET(200, null, null, {
        overrides: {
          url: maintenanceUrl
        },
        firePostRequestCallback: false
      });
    });
    _defineProperty(this, "describeSwagger", function (queryParams) {
      return _this2._GET(200, '/swagger.json', queryParams);
    });
    _defineProperty(this, "describeOpenApi", function (queryParams) {
      return _this2._GET(200, '/openapi.json', queryParams);
    });
    _defineProperty(this, "getEmailAlerts", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _this2.swaggerOp('listEmailAlerts', args);
    });
    this.server = server;
    this.token = _token;
    this.headers = _headers;
    this.isRaw = false;
    this.postRequestCallback = postRequestCallback;
    return new Proxy(this, {
      get: function get(target, property, receiver) {
        if (property in target) return target[property];
        if (!target.spec) {
          target.spec = BaseClient.getDefaultSpec();
          if (property === 'spec') {
            return target.spec;
          }
        }
        var operationId = property;
        if (target.spec[operationId]) {
          var f = function f() {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            return target.swaggerOp(operationId, args);
          };
          target[operationId] = f;
          return f;
        }
        return undefined;
      }
    });
  }
  _createClass(BaseClient, null, [{
    key: "forLiveServer",
    value: function forLiveServer(endpoint) {
      var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var postRequestCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var isRaw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var server = new LiveServer(endpoint);
      var c = new BaseClient(server, token, {}, postRequestCallback);
      c.isRaw = isRaw;
      return c;
    }
  }, {
    key: "getDefaultSpec",
    value: function getDefaultSpec() {
      if (!BaseClient.defaultSpec) {
        BaseClient.defaultSpec = require('./spec.json');
      }
      return BaseClient.defaultSpec;
    }
  }, {
    key: "swaggerToSpec",
    value: function swaggerToSpec(swaggerObj) {
      var ops = {};
      Object.entries(swaggerObj.paths).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          path = _ref10[0],
          v = _ref10[1];
        Object.entries(v).forEach(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
            method = _ref12[0],
            op = _ref12[1];
          var responseCodes = Object.keys(op.responses);
          if (responseCodes.length !== 1) throw new Error("Expected exactly one response code for operationId ".concat(op.operationId, ", but found ").concat(responseCodes));
          ops[op.operationId] = [method.toUpperCase(), path, (op.parameters || []).filter(function (p) {
            return p.in === 'path';
          }).map(function (p) {
            return p.name;
          }), Number(responseCodes[0]), (op.parameters || []).some(function (p) {
            return p.in === 'formData';
          }) ? 2 : (op.parameters || []).some(function (p) {
            return p.in === 'body';
          }) ? 1 : 0, (op.parameters || []).some(function (p) {
            return p.in === 'query';
          }) ? 1 : 0];
        });
      });
      return ops;
    }
  }]);
  return BaseClient;
}();
module.exports = {
  HeliumClient: BaseClient,
  HeliumClientError: HeliumClientError
};